import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function RotaProtegida({ children, tipoNecessario }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" />;
  }

  try {
    const dadosUsuario = jwtDecode(token);

    const agora = Math.floor(Date.now() / 1000);
    if (dadosUsuario.exp < agora) {
      localStorage.removeItem("token");
      alert("Sua sessão expirou. Por favor, faça login novamente.");
      return <Navigate to="/" />;
    }

    // Suporte para tipoNecessario como string ou array
    const tiposPermitidos = Array.isArray(tipoNecessario)
      ? tipoNecessario
      : [tipoNecessario];

    if (tipoNecessario && !tiposPermitidos.includes(dadosUsuario.tipoUsuario)) {
      return <Navigate to="/bloqueado" />;
    }

    return children;
  } catch (error) {
    console.error("Erro ao decodificar o token:", error);
    localStorage.removeItem("token");
    return <Navigate to="/login" />;
  }
}

export default RotaProtegida;
